import { alpha } from "@material-ui/core";

const APP_ENV = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV
  : process.env.STORYBOOK_APP_ENV;

export const PRIMARY_COLOR_PROD = "#124E5D";
const PRIMARY_COLOR_STAG = "#113D5C"; // before: "#00A9EC";
const PRIMARY_COLOR_DEV = "#5B115C"; // before:  "#A72894"

// main colors
export const primaryColor =
  APP_ENV === "production"
    ? PRIMARY_COLOR_PROD
    : APP_ENV === "develop"
      ? PRIMARY_COLOR_DEV
      : PRIMARY_COLOR_STAG;

export const PrimaryFaded = alpha(primaryColor, 0.7);

export const secondaryColor = "#FFBD55";
export const cancelColor = "#CCC";
export const defaultColor = "#000";
export const defaultBackground = "#FFF";
export const successColor = "#00AC6A";
export const warningColor = "#FFB236";
export const darkSeaGreen = "#1C8E64"; // Euclayptus ?
export const tangerineError = "#FF6838";
export const darkGoldenrod = "#CB9744";
export const infoColor = "#2CA8FF";
export const errorColor = "#EF472F";
// other colors (used for dashboards mainly)
export const darkteal = "#1e434a";
export const lightred = "#fe938b";
export const blue = "#19548f";
export const yellow = "#febd55";
export const darkgray = "#6c6c6c";
export const lightpurple = "#bb7ab4";
export const purplePzazz = "#FB53D8";
export const purpleTransparent = "rgba(251, 83, 216, 0.1)";
export const lightblue = "#639faa";
export const lightgray = "#c6c6c6";
export const predefinedColors = [
  "rgb(255,0,0)",
  "rgb(0,255,0)",
  "rgb(0,0,255)",
  "rgb(255,255,0)",
  "rgb(0,255,255)",
  "rgb(255,0,255)",
  "rgb(192,192,192)",
  "rgb(128,0,0)",
  "rgb(128,128,0)",
  "rgb(0,128,0)",
  "rgb(128,0,128)",
  "rgb(0,128,128)",
  "rgb(0,0,128)",
  "rgb(70,130,180)",
  "rgb(220,20,60)",
];

// Extended colors (dashboards)
export const orange = "#ff5722";
export const teal = "#4d7a85";
export const tealLight = "#608892";
export const bluegray = "#87a5ad";
export const lightbluegray = "#c3d2d6";

export const black = "#222222";
export const red = "#EF472F";
export const deepblue = "#111B34";

// New theme colors
export const Background = "#F3F6F7";
export const Red = "#EF472F";
export const GreyLight = "#e6e6e6";
export const GreyMediumLight = "#eeeeee";
export const GreyMedium = "#c6c6c6";
export const GreyDark = "#6C6C6C";
export const GreyBorder = "#b8b8b8";
export const Black = "#2c2c2c";
export const OffWhite = "#f5f5f5";
export const OffWhiteLight = "#fbfbfb";
export const WhiteSmoke = "#EAEEF2";
export const BlueChalk = "#F7F9FA";
export const White = "#fefefe";
export const Green = "#124e5d";
export const GreenDark = "#209612";
export const GreyState = "#6B6B6B";

export const BurntOrange = "#FF8964";
export const LightPeachBrand = "#FFEEE9";
export const MidnightBlue = "#082127";

export const LightBeige = "#F5EADA";
export const BrandOrangeBrown = "#CB9744";

export const PalePink = "#CFD9E0";
export const YellowSecondary = "#FEC466";
export const Yellow = "#FFBD55";
export const PrimaryTint = "#D0DCDF";

export const Teal = "#c4d3d6";
export const DarkTeal = "#71959e";
export const MediumTeal = "#88a6ae";
export const TealLight = "#e7edef";
export const TealLight2 = "#e6eced";
export const Teal10 = "#2A606D";

export const Silver = "#ccc";

export const InfoColor = "#2CA8FF";
export const SuccessColor = "#00AC6A";
export const ErrorColor = "#EF472F";
export const FordGray = "#979797";
export const steelBlue = "#92AEB4";

export const brownishGrey = "#6c6c6c";
export const whiteCoffee = "#E6D7D2";
export const BrightOrange = "rgba(254, 189, 85)";
export const PaleYellowOrange = "rgba(254, 189, 85, 0.1)";
export const PaleGray = "rgba(150, 150, 150, 0.1)";

export const Mustard = "#FEBD55"; // rgba(254, 189, 85, 1)
export const Mustard80 = "#FFF2DD";
export const Mustard90 = "#FFF8EE"; // rgba(255, 248, 238, 1)

export const Euclayptus = "#1C8E64";
export const Euclayptus80 = "#E8F4F0";
export const VeryLightGray = "#FEFEFE";
export const Rust = "#A02B00";
export const Butter = "#FFD977";
export const RussetBrown = "#803000";

//Transparent
export const darkGraySemiTransparent = "rgba(52, 53, 53, 0.5)";

//Step Status
export const DONEColor = Euclayptus80;
export const DONETextColor = "#1C8E64";

export const PENDINGTextColor = "#FEFEFE";
export const PENDINGColor = "#E6E6E6";

export const WARNINGColor = "#F5EADA";
export const WARNINGTextColor = "#CB9744";
export const WARNINGTextColor2 = "#462F00";
export const WARNINGTextColor3 = "#a54800";
export const WARNINGColorSubdued = "#F2EEE6";

export const FAILEDColor = "#FFEEE9";
export const FAILEDTextColor = "#FF6838";

export const INPROGRESSColor = "#E7EDEF";
export const INPROGRESSTextColor = "#124E5D";
export const StrokeLowEnphasis = "#F7F9FA";

//order status
export const draft = "#E7E7E7";
export const draftText = "#6B6B6B";

export const waiting = "#FFFBEB";
export const waitingText = "#A54800";

export const confirmed = "#F2F1F9";
export const confirmedText = "#5C50B2";

export const delivery = "#FFF9EE";
export const deliveryText = "#FEBD55";

export const cancelled = "#FFF0EB";
export const cancelledText = "#F54100";

export const delivered = "#E6F0ED";
export const deliveredText = "#006C4A";

// Other
export const MatchingRoute = "#03AA46";
export const PrimaryTeal = "#124E5D";
export const PrimaryTealLight = "#E7EDEF";
export const AlertOrange = "#A54800";
export const LightBackground = "#FFFBEB";
export const PineGreen = "#006C4A";
export const PineGreenLight = "#E6F0ED";

export const fireEngineRed = "#DB2527";
export const vibrantOrange = "#F97316";
export const saffronYellow = "#FBBF24";
export const royalBlue = "#2563EB";
export const jungleGreen = "#08956A";
export const mintGreen = "#67FFAF";
